export default __webpack_public_path__ + "static/feature9banner-1a7dcc42fb2f0e951fa6869f2265c3f7.svg";